import React from 'react';
import { Heart } from 'lucide-react';

const Header = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center space-x-2">
            <Heart className="w-6 h-6 text-blue-600" />
            <span className="text-xl font-semibold text-gray-900">Understanding Grief</span>
          </div>
          
          <nav className="hidden md:flex items-center space-x-8">
            <a href="#stages" className="text-gray-600 hover:text-blue-600 transition-colors duration-200">
              The Stages
            </a>
            <a href="#coping" className="text-gray-600 hover:text-blue-600 transition-colors duration-200">
              Coping
            </a>
            <a href="#resources" className="text-gray-600 hover:text-blue-600 transition-colors duration-200">
              Resources
            </a>
            <a href="#support" className="text-gray-600 hover:text-blue-600 transition-colors duration-200">
              Get Support
            </a>
          </nav>
          
          <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200">
            <a href="tel:3212620256" className="text-white no-underline">Contact Counselor</a>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
